import React from 'react';
import './TourFooter.css';

export const TourFooter = () => {
  return (
    <div className="tour-footer">
      <img 
        className="tour-footer__logo-image" 
        src="icons/yournest_logo.svg" 
        alt="yourNEST logo"
      />
      <div className="tour-footer__info-block">
        <div className="tour-footer__info-head">
          <div onClick={() => window.open('https://docs.google.com/document/d/1znqpLk-QoA5G8f9fWghdrQy_a8Gp42S7Fn1xggngL8Y/edit?usp=sharing', '_blank')}>
            개인정보처리방침
          </div>
          <div> &nbsp;·&nbsp; </div>
          <div onClick={() => window.open('https://docs.google.com/document/d/114zQPH5UyiAoLPQT7USVK5bCLcIpKifdYwQDQh752zw/edit?usp=sharing', '_blank')}>
            이용약관
          </div>
        </div>
        
        <div className="tour-footer__info-text-name">
          유어네스트<br/>
          주소 : 경기도 고양시 일산동구 중앙로 1036 고양중장년기술창업센터 3-2 (우 : 10450)<br/>
          사업자번호 : 8833401302  대표메일 : elliot@urnest.space 고객센터 : 010-7706-2179<br/>
          Copyright ⓒyourNEST. All Rights Reserved
        </div>
        
        <div className="tour-footer__info-image-area">
          <img 
            className="tour-footer__info-image" 
            src="/icons/logo_icon_frip.png" 
            onClick={() => window.open('https://www.frip.co.kr/hosts/26057/products', '_blank')} 
            style={{cursor: 'pointer'}}
            alt="Frip"
          />
          <img 
            className="tour-footer__info-image" 
            src="/icons/logo_icon_naver.png" 
            onClick={() => window.open('https://smartstore.naver.com/atelier_tour', '_blank')} 
            style={{cursor: 'pointer'}}
            alt="Naver"
          />
          <img 
            className="tour-footer__info-image" 
            src="/icons/logo_icon_instagram.png" 
            onClick={() => window.open('https://www.instagram.com/atelier_tour_official?igsh=bmt3aG94bmQ2NWxs', '_blank')} 
            style={{cursor: 'pointer'}}
            alt="Instagram"
          />
        </div>
      </div>
    </div>
  );
};